import MiniCartIcon from '../common/MiniCartIcon';
import SharePopup from '../common/SharePopup';
import { shareButtonClick } from '@/utils/weeeTracker/methods';
import { defaultBack } from '../common/HeaderNew';
import { useRouter } from 'next/router';
import { CaratLeft } from '@weee-fe/kunlunicon';
import { twMerge } from 'tailwind-merge';

type StudentBenefitsHeaderProps = {
  className?: string;
  title?: string;
  shareData: any;
  onBack?: () => void;
  shareBeforeClick?: () => void;
};

const StudentBenefitsHeader = ({
  className,
  title,
  shareData,
  onBack,
  shareBeforeClick
}: StudentBenefitsHeaderProps) => {
  const router = useRouter();

  const handleBack = () => {
    onBack?.();
    defaultBack(router);
  };

  const handleShareBeforeClick = (show: () => void) => {
    shareBeforeClick?.();
    show();
  };

  return (
    <div
      className={twMerge(
        'relative w-full h-12 flex items-center justify-between px-5 text-navbar-fg-default',
        className
      )}>
      <div className="flex items-center justify-center h-10 w-10 rounded-full" onClick={handleBack}>
        <CaratLeft fontSize={24} />
      </div>
      {title && (
        <div className="absolute left-0 right-0  pointer-events-none">
          <span className="block px-24 text-ellipsis overflow-hidden whitespace-nowrap enki-body-base-medium text-navbar-fg-default text-center">
            {title}
          </span>
        </div>
      )}
      <div className="flex items-center gap-1">
        <SharePopup
          data={shareData}
          showFbHeadConfig={false}
          onBeforeShow={show => {
            handleShareBeforeClick(show);
          }}
          iconClassName={'w-10 h-10 rounded-full text-center leading-[40px]'}
        />
        <MiniCartIcon />
      </div>
    </div>
  );
};

export default StudentBenefitsHeader;
